import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M4815 8524 c-799 -79 -1500 -393 -2056 -922 -88 -84 -169 -170 -282
-300 -91 -106 -244 -324 -329 -473 -153 -264 -281 -595 -354 -914 -55 -242
-76 -422 -81 -708 -8 -378 16 -608 97 -927 152 -607 457 -1139 909 -1590 284
-283 557 -478 914 -650 416 -201 811 -300 1321 -331 442 -28 949 50 1371 208
506 191 982 517 1328 913 240 274 374 472 527 780 393 788 457 1727 178 2600
-59 184 -184 467 -281 635 -77 134 -261 403 -296 435 -3 3 -28 32 -56 65 -80
97 -252 271 -360 364 -501 436 -1092 700 -1785 796 -110 16 -662 29 -765 19z
m563 -134 c373 -27 745 -117 1067 -259 855 -378 1483 -1064 1780 -1944 478
-1419 -48 -2974 -1287 -3803 -405 -271 -835 -436 -1348 -516 -128 -20 -182
-22 -470 -22 -288 -1 -342 2 -475 22 -697 106 -1302 403 -1799 882 -540 521
-875 1181 -983 1940 -22 157 -25 666 -5 830 90 732 391 1368 887 1879 269 277
545 482 869 646 403 204 789 310 1271 348 97 8 358 6 493 -3z"
          />
          <path
            d="M3580 7414 c-113 -24 -223 -120 -267 -234 -17 -42 -18 -135 -21
-1414 -3 -1523 -6 -1440 65 -1544 44 -64 129 -127 198 -147 44 -13 254 -15
1576 -13 l1525 3 67 34 c80 40 139 101 175 179 l27 57 3 1374 c3 1530 6 1445
-66 1550 -44 64 -108 114 -189 144 l-58 22 -1485 2 c-1249 1 -1495 -1 -1550
-13z m3092 -107 c64 -31 119 -89 152 -157 l21 -45 0 -1365 0 -1365 -21 -46
c-30 -64 -88 -125 -148 -157 l-51 -27 -1515 0 -1515 0 -43 23 c-67 35 -127 97
-153 155 l-24 52 0 1360 c0 1314 1 1362 19 1409 32 83 115 159 206 187 14 4
698 7 1520 6 l1495 -2 57 -28z"
          />
          <path
            d="M5770 7274 c-15 -39 -13 -41 38 -49 65 -9 167 -51 232 -95 77 -52
169 -154 204 -225 33 -68 66 -183 66 -232 0 -32 1 -33 41 -33 l42 0 -6 73
c-15 207 -155 417 -342 514 -92 47 -172 73 -227 73 -32 0 -40 -4 -48 -26z"
          />
          <path
            d="M5773 7133 c-7 -2 -13 -22 -13 -42 0 -38 1 -38 45 -44 68 -10 146
-51 204 -108 68 -69 102 -141 109 -229 l5 -70 38 0 39 0 0 65 c0 68 -25 151
-65 215 -55 87 -193 187 -285 205 -19 3 -42 8 -50 10 -8 2 -21 1 -27 -2z"
          />
          <path
            d="M4225 7028 c-2 -13 -14 -77 -25 -143 -11 -66 -25 -140 -30 -165 -5
-25 -32 -178 -60 -340 -29 -162 -74 -419 -101 -570 -27 -151 -74 -414 -105
-585 -30 -170 -56 -316 -59 -322 -3 -10 85 -13 423 -13 l427 0 1 -93 c2 -247
136 -436 369 -519 108 -39 197 -52 350 -53 378 -1 649 135 776 390 42 85 59
154 65 270 10 168 -25 275 -122 372 -48 48 -158 113 -191 113 -26 0 -12 19 20
25 103 23 246 118 316 212 83 111 114 213 114 368 0 119 -23 197 -83 285 -50
73 -96 112 -187 156 -114 55 -245 77 -423 70 -277 -10 -480 -98 -593 -256
l-42 -59 -232 0 c-156 -1 -233 2 -233 9 0 13 33 202 61 348 10 57 19 105 19
108 0 2 183 4 406 3 223 0 407 1 409 3 2 3 75 390 75 401 0 4 -301 7 -670 7
l-670 0 -5 -22z m1575 -985 c17 -10 43 -35 58 -57 24 -35 27 -48 27 -120 0
-70 -4 -87 -27 -128 -65 -110 -173 -158 -359 -158 l-106 0 -11 -42 c-6 -24
-23 -110 -37 -193 -15 -82 -29 -160 -32 -172 -5 -23 -5 -23 114 -23 178 0 258
-32 304 -122 74 -146 -4 -328 -161 -372 -145 -41 -287 7 -347 117 -28 51 -22
209 14 385 l29 142 -414 0 -414 0 5 23 c3 12 22 117 42 232 20 116 39 216 41
223 3 9 97 12 428 12 l424 0 7 37 c16 87 87 183 162 218 75 36 191 35 253 -2z"
          />
          <path
            d="M5756 6934 c-3 -9 -6 -27 -6 -40 0 -20 5 -24 33 -24 76 0 144 -74
153 -168 l7 -62 38 0 39 0 0 43 c0 107 -57 204 -144 246 -51 25 -111 28 -120
5z"
          />
          <path
            d="M5697 6770 c-33 -26 -51 -79 -38 -112 33 -86 161 -90 190 -6 17 49
13 68 -23 104 -40 40 -89 46 -129 14z"
          />
          <path
            d="M3168 3673 l-38 -4 0 -355 0 -354 225 0 225 0 0 65 0 65 -145 0 -145
0 0 85 0 85 120 0 120 0 0 63 0 62 -120 -1 -120 -1 0 84 0 83 146 0 147 0 -7
31 c-3 17 -6 46 -6 64 l0 33 -182 -1 c-101 0 -200 -2 -220 -4z"
          />
          <path
            d="M4460 3319 l0 -361 153 4 c168 6 212 17 279 69 80 64 118 160 118
298 -1 190 -82 301 -246 336 -38 8 -122 15 -186 15 l-118 0 0 -361z m277 220
c74 -28 112 -99 113 -210 0 -159 -63 -239 -190 -239 l-50 0 0 230 0 230 49 0
c27 0 62 -5 78 -11z"
          />
          <path
            d="M5395 3646 c-25 -59 -245 -669 -245 -678 0 -5 34 -8 77 -6 l76 3 26
80 26 80 119 0 120 0 27 -80 26 -80 82 -3 c44 -2 81 1 81 5 0 4 -15 51 -34
103 -46 128 -201 548 -215 583 -10 27 -13 28 -82 26 -70 -2 -72 -3 -84 -33z
m124 -280 c17 -54 31 -102 31 -106 0 -4 -34 -8 -75 -9 -41 -1 -75 2 -75 6 0 9
46 152 62 196 6 15 14 24 18 20 5 -4 22 -52 39 -107z"
          />
          <path
            d="M5860 3614 l0 -64 90 0 90 0 0 -295 0 -295 75 0 75 0 0 295 0 295 95
0 95 0 0 63 0 63 -260 1 -260 1 0 -64z"
          />
          <path
            d="M6726 3668 c-9 -32 -154 -431 -193 -533 -8 -22 -26 -71 -39 -108
l-23 -68 80 3 80 3 28 80 28 80 119 3 120 3 27 -86 28 -85 80 0 c43 0 79 2 79
5 0 3 -36 103 -81 222 -45 120 -100 272 -124 338 -24 66 -46 128 -50 138 -6
14 -20 17 -81 17 -51 0 -76 -4 -78 -12z m119 -298 c19 -57 35 -108 35 -112 0
-4 -34 -8 -76 -8 l-76 0 7 28 c12 48 68 203 72 199 2 -2 19 -51 38 -107z"
          />
          <path
            d="M3865 3643 c-43 -16 -115 -58 -115 -67 0 -4 51 -98 57 -105 1 -2 11
3 20 11 25 21 98 48 132 48 41 0 81 -35 81 -71 0 -53 -63 -89 -157 -89 l-43 0
0 -55 0 -55 75 0 c115 0 152 -28 143 -105 -7 -66 -111 -90 -195 -47 -23 12
-45 22 -47 22 -11 0 -56 -101 -50 -111 3 -6 30 -22 58 -35 73 -34 209 -34 281
0 28 13 58 32 67 42 45 51 61 145 34 207 -16 38 -72 97 -92 97 -22 0 -16 14
14 31 62 35 81 154 35 217 -49 68 -198 101 -298 65z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
